export { default } from './AIButton';
